module.exports = __webpack_public_path__ + "dbc45a2d7976bdd340b02110f7775c5b.pdf";